import axios from 'axios'
import axiosConfig from '../../../../config/axios'
import { StandardResult } from '../../../core/_core'

const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_URL = `${API_URL}/identity/Authentication/authenticate`
export const VALIDATE_LOGIN_URL = `${API_URL}/identity/Authentication/isAuthenticated`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `authentication/forgot-password`

// Server should return StandardResult
export function authenticate(email: string, password: string) {
  return axios.post<StandardResult>(LOGIN_URL, {
    email,
    password,
  })
}

export function isAuthenticated() {
  return axios.get<StandardResult>(VALIDATE_LOGIN_URL)
}


// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

export function forgotPassword(username: string) {
  return axiosConfig.post<StandardResult>(`${REQUEST_PASSWORD_URL}`,
    {
      params: {
        username: username
      },
    })
}